import React from 'react';
import {
  Page, Section, SectionTitleUnderlined, ExperienceList,
  LineList, SkillsInline, ContactRow
} from './_shared';

/**
 * "Compact" template (key: compact).
 *
 * Dense single-column layout for resumes with lots of experience. Tighter
 * line height, smaller body size, shorter section gaps. Same ATS-friendly
 * single-column flow as Modern, just engineered to fit ~30% more content
 * on a single page.
 */

const ACCENT = '#1e3a8a';      // deep blue — trustworthy

const Compact = ({ data }) => {
  const fontFamily = "'Inter', 'Helvetica Neue', Arial, sans-serif";
  return (
    <Page
      accent={ACCENT}
      fontFamily={fontFamily}
      padding="0.55in"
      style={{ lineHeight: 1.35, fontSize: '10pt' }}
    >
      <header style={{ marginBottom: '0.5rem' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          flexWrap: 'wrap',
          gap: '0.5rem'
        }}>
          <h1 style={{
            fontSize: '22pt',
            fontWeight: 700,
            margin: 0,
            letterSpacing: '-0.01em',
            color: '#0f172a'
          }}>
            {data.fullName}
          </h1>
          {data.jobTitle && (
            <div style={{
              fontSize: '10.5pt',
              color: ACCENT,
              fontWeight: 500
            }}>
              {data.jobTitle}
            </div>
          )}
        </div>
        <ContactRow data={data} style={{ marginTop: '4px', fontSize: '9pt' }} />
      </header>

      <div style={{ height: '1px', background: ACCENT, marginBottom: '0.5rem' }} />

      {data.summary && (
        <Section style={{ marginBottom: '0.4rem' }}>
          <SectionTitleUnderlined accent={ACCENT} size="10pt">Summary</SectionTitleUnderlined>
          <p style={{ margin: 0 }}>{data.summary}</p>
        </Section>
      )}

      {data.skills && (
        <Section style={{ marginBottom: '0.4rem' }}>
          <SectionTitleUnderlined accent={ACCENT} size="10pt">Skills</SectionTitleUnderlined>
          <SkillsInline skills={data.skills} separator=" • " />
        </Section>
      )}

      {data.experience && (
        <Section style={{ marginBottom: '0.4rem' }}>
          <SectionTitleUnderlined accent={ACCENT} size="10pt">Experience</SectionTitleUnderlined>
          <ExperienceList text={data.experience} accent={ACCENT} />
        </Section>
      )}

      {data.education && (
        <Section style={{ marginBottom: '0.4rem' }}>
          <SectionTitleUnderlined accent={ACCENT} size="10pt">Education</SectionTitleUnderlined>
          <LineList text={data.education} gap="0px" />
        </Section>
      )}

      {data.certifications && (
        <Section style={{ marginBottom: '0.4rem' }}>
          <SectionTitleUnderlined accent={ACCENT} size="10pt">Certifications</SectionTitleUnderlined>
          <LineList text={data.certifications} gap="0px" />
        </Section>
      )}

      {data.languages && (
        <Section style={{ marginBottom: 0 }}>
          <SectionTitleUnderlined accent={ACCENT} size="10pt">Languages</SectionTitleUnderlined>
          <LineList text={data.languages} gap="0px" />
        </Section>
      )}
    </Page>
  );
};

export default Compact;
